<template>
	<div>
		<v-card-title>
			Prośby o dołączenie
		</v-card-title>
		<v-card-text>
			<groups-list v-if="groups && groups.length" :data="groups" :infinite-scrolling="null" />
			<div v-if="loading">
				<div v-for="i in 5" :key="i">
					<v-skeleton-loader
						type="text, paragraph"
						class="mt-8"
					></v-skeleton-loader>
				</div>
			</div>
			<div v-else-if="(groups && !groups.length) || !groups" class="text-muted">Brak próśb do wyświetlenia</div>
		</v-card-text>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import GroupsList from "@/components/groups/GroupsList";
export default {
	name: "RequestedGroups",
	components: {
		GroupsList,
	},
	data() {
		return {
			loading: false
		}
	},
	computed: {
		...mapGetters({
			groups: "groups/userRequests",
		}),
	},
	methods: {
		...mapActions('groups', [
			'getUserRequests'
		]),
		async getRequests() {
			this.loading = true;
			await this.getUserRequests()
			this.loading = false;
		}
	},
	created() {
		this.getRequests()
	},
}
</script>

<style scoped>

</style>
